import { forwardRef } from 'react';
import Cropper from 'react-easy-crop';

import { useTranslation } from '@gem/modules/i18n';

import { ErrorHandler } from '../ErrorHandler/ErrorHandler';
import { useImageCropperPresenter } from './ImageCropper.presenter';
import styles from './ImageCropper.styles.m.css';
import { IImageCropperHandlers, IImageCropperProps } from './ImageCropper.types';
import { getCropAreaClassName, getCropperObjectFit } from './ImageCropper.utils';
import { ImageCropperSlider } from './ImageCropperSlider/ImageCropperSlider';

export const ImageCropper = forwardRef<IImageCropperHandlers, IImageCropperProps>((props, ref) => {
  const { image, type = 'square', onError } = props;
  const { t } = useTranslation();

  const presenter = useImageCropperPresenter({
    image,
    onError,
    ref,
  });

  const cropAreaClassName = getCropAreaClassName(type);
  const cropperObjectFit = getCropperObjectFit(type);

  return (
    <>
      <div className={styles.changeProfilePhoto}>
        <ErrorHandler onError={presenter.onCropperError}>
          <Cropper
            image={image}
            crop={presenter.crop}
            zoom={presenter.zoom}
            cropShape={type === 'round' ? 'round' : 'rect'}
            objectFit={cropperObjectFit}
            classes={{ cropAreaClassName }}
            aspect={4 / 4}
            showGrid={false}
            onCropChange={presenter.onCropChange}
            onCropComplete={presenter.onCropComplete}
            onZoomChange={presenter.onZoomChange}
          />
        </ErrorHandler>
        {type === 'cover' && (
          <div className={styles.coverCustomContainer}>
            <div className={styles.coverCustomRow}>
              <span className={styles.coverCustomText}>{t('space_tip_visibility_mobile')}</span>
            </div>
            <div className={styles.coverCustomRow}>
              <span className={styles.coverCustomText}>{t('space_tip_visibility_web')}</span>
            </div>
            <div className={styles.coverCustomRow}></div>
          </div>
        )}
      </div>
      <div className={styles.control}>
        <ImageCropperSlider
          className={styles.slider}
          name="zoom"
          value={presenter.zoom}
          max={3}
          min={1}
          step={0.1}
          onChange={presenter.onZoomChangeSlider}
        />
      </div>
    </>
  );
});
